<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{
        name: data.item.idEtapa == 97 ?'resumenInversion': data.item.idEtapa == 98 ?'metodosPago': data.item.idEtapa == 99 ?'distribucionPagoPTIv5': '',
        params:
        data.item.idEtapa == 97 ?
        {
         idPti:        data.item.idPti,
         idSolicitudEtapa: data.item.idSolicitudEtapa,
         idSolicitud:  data.item.idSolicitud,
         idEtapa:          data.item.idEtapa}:

        data.item.idEtapa === 98?
        {
        idPti:            data.item.idPti,
        idSolicitudEtapa: data.item.idSolicitudEtapa,
        idSolicitud:      data.item.idSolicitud,
        idEtapa:          data.item.idEtapa,
        opcion:           data.item.opcionAceptada
        }:
         data.item.idEtapa === 99?
        {
        idPti:            data.item.idPti,
        idSolicitudEtapa: data.item.idSolicitudEtapa,
        idSolicitud:      data.item.idSolicitud,
        idEtapa:          data.item.idEtapa,
        opcion:           data.item.opcionAceptada
        }:{},
      }"
    >
      <p
          class="letraColorAzulPrincipal letraEstiloNegrita"
      >
        {{ data["item"].nombrePaciente }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "LinkPacientePtiVisibleComponenteV5",
  props: {
    data: Object,
    resource: Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>

</style>